module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.5a5f0723.woff";